/* eslint-disable max-len */

export default {
  lang: 'Português',
  homeScreen: {
    title: '', // Produto específico
    stayConnected: 'Fique Conectado',
    comingSoon: 'Em Breve',
    messages: 'Mensagens',
    popup: {
      title: 'Central Florida Insiders Benefícios para graduados',
      body: "Conselheiros, damos-vos as boas-vindas ao Central Florida Tourism Institute. Como agradecimento, estamos oferecendo aos consultores que se formam como um Central Florida Insider acesso a esses benefícios exclusivos.<br/><br/>O Central Florida Insiders Graduate Benefits consiste em um pacote de presente de formatura, um ingresso de 1 dia para o LEGOLAND® Theme Park, um passe livre para o Florida Children's Museum e mais ofertas e descontos para resgatar durante sua visita. A graduação primeiro, que irá desbloquear o seu mosaico exclusivo no {Link}, onde pode então verificar os seus números IATA para aceder e obter detalhes sobre como resgatar os seus benefícios.",
      sellSection: 'secção de VENDA',
    },
  },
  loginScreen: {
    version2: {
      homeTitle:
        'Vamos ver se conseguimos encontrar um perfil existente para você em nosso sistema.',
      homeTitleSub:
        'Digite o endereço de e-mail que você costuma usar para fazer login em programas de treinamento.',
      noAccount:
        'Nenhuma conta encontrada ({email}), tente com outro e-mail ou crie uma conta agora.',
      continueButton: 'Continuar',
      success:
        'Conta atualizada com sucesso! Você será redirecionado para a página inicial em breve.',
      successNewAccount:
        'Para completar seu registro, você receberá um e-mail de confirmação para verificar sua conta.',
      loginButton: 'Entrar',
      matchFound:
        'Encontramos uma correspondência, por favor, preencha sua senha para continuar.',
      magicLink: 'Entre via um link em seu e-mail:',
      magicLinkButton: 'Solicitar Link Mágico',
      magicLinkTitle:
        'Receba um link direto enviado para seu e-mail que permitirá que você entre instantaneamente.',
      otherEmailButton: 'Enviar',
      title:
        'Por favor, reserve um momento para preencher todas as informações abaixo, pois isso preencherá seu perfil pessoal e informações de contato.',
      titleIndustry:
        'Por favor, reserve um momento para preencher todas as informações abaixo, pois isso preencherá seu perfil pessoal e informações de contato.',
      register: 'Criar uma conta',
      agent: 'Consultor de Viagens',
      visitor: 'Visitante da Indústria',
      step1: 'Passo 1: Tipo de Usuário',
      step2: 'Passo 2: Criar Uma Conta',
      step3: 'Passo 3: Crie Seu Perfil',
      marketingOptIn:
        'Tem certeza de que não está interessado em manter-se conectado com a equipe de comércio de viagens deste programa?',
      optIn: 'Sim, estou interessado',
      optOut: 'Não estou interessado',
      step2Sub1: 'Conte-nos Sobre Você',
      step2Sub2: 'Conte-nos Sobre Seu Negócio',
      privacyHead: 'PREFERÊNCIAS DE COMUNICAÇÃO',
      privacySub:
        'Marque as caixas abaixo para garantir que você receba comunicações importantes da equipe de comércio de viagens do fornecedor (atualizações de produtos e anúncios, recompensas, incentivos, FAMs, etc.) e iniciativas de suporte de rede e vendas de comércio de viagens da TravPRO Mobile.',
      privacy:
        'Nós protegemos sua privacidade e nunca vendemos, abusamos ou traímos sua confiança.',
      store: 'Baixe facilmente este programa na sua loja de aplicativos:',
      powered: 'DESENVOLVIDO POR',
      toastMessage: {
        forgotSuccess:
          'Enviamos o link de redefinição de senha para o seu e-mail! Você será redirecionado para a página de login em 10 segundos.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
        magicLinkMessage: 'Por favor, espere, estamos fazendo login agora.',
        magicLinkError:
          'Não conseguimos encontrar sua conta em nosso banco de dados, faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkError1:
          'Não conseguimos encontrar um token válido, faça login ou solicite um novo link mágico. Se esse problema persistir, entre em contato conosco: info@travpromobile.com.',
        magicLinkError2:
          'Não conseguimos encontrar sua conta em nosso banco de dados, faça login manualmente. Você será redirecionado em 10 segundos.',
        magicLinkSuccess:
          'Verifique seu e-mail em {email}. Tem um link mágico que permitirá que você faça login.',
        magicLinkErrorWait:
          'Por favor, espere 5 minutos entre as solicitações de link mágico.',
        emailNotFoundError:
          'O endereço de e-mail que você digitou não pode ser encontrado em nossos registros. Verifique se há erros de digitação ou crie uma conta.',
      },
      errors: {
        zipCodeNotFound: 'CEP não encontrado, tente novamente',
        zipCodeOnlyNumbers: 'O CEP só pode conter números',
        password: 'Por favor, digite uma senha',
        passwordNotMatching: 'As senhas que você digitou não correspondem',
        passwordTooShort: 'A senha deve ter pelo menos 8 caracteres',
        emailExists:
          'Este endereço de e-mail já existe ou é inválido. Por favor, tente outro endereço de e-mail ou faça login em sua conta.',
        fillInAllFields: 'Por favor, preencha todos os campos obrigatórios',
        fillInEmail: 'Por favor, preencha seu e-mail.',
        emailNotExisting: 'O endereço de e-mail que você digitou não existe.',
      },
      fields: {
        forgotSubCopy: 'Esqueceu sua senha e deseja alterá-la? ',
        forgotSubCopy2:
          'Quer evitar a senha por completo? Enviaremos um e-mail com um link mágico que permitirá que você faça login automaticamente no programa. ',
        city: 'Cidade',
        companyName: 'Nome da Empresa',
        role: 'Seu Cargo',
        description: 'Qual melhor descreve o negócio da sua empresa?',
        country: 'País',
        password: 'Senha',
        passwordRegister: 'Escolha uma Senha (mínimo de 8 caracteres)',
        passwordConfirm: 'Confirmar Senha',
        firstName: 'Nome',
        lastName: 'Sobrenome',
        agency: 'Nome da Sua Agência',
        title: 'Seu Cargo (Selecione Um)',
        company: 'Nome da Empresa',
        select: 'Selecione uma opção abaixo',
        state: 'Estado',
        province: 'Província/Região/Estado',
        zipCode: 'CEP',
        postalCode: 'Código Postal',
        affiliate: 'Qual é a principal afiliação da sua agência?',
        hostAgency: 'Sua Agência Anfitriã?',
        executive: 'Executivo',
        management: 'Gestão',
        marketing: 'Marketing',
        sales: 'Vendas',
        coordinator: 'Coordenador',
        other: 'Outro',
        opt: 'Fique conectado com a equipe de comércio de viagens deste programa e receba atualizações.',
        optMarketing:
          'Fique conectado com a TravPRO sobre programas e eventos semelhantes.',
        retail: 'Loja de Varejo',
        home: 'Agente Baseado em Casa',
        independent: 'Contratante Independente',
        host: 'Agência Anfitriã',
        call: 'Central de Atendimento ou Agência Baseada na Web',
        other: 'Outro ',
        describes: 'O que melhor descreve você e o negócio da sua agência? ',
      },
    },
    title:
      'Programa de Treinamento e Habilitação de Vendas para Profissionais de Viagens', // Produto específico (texto de TravPRO ou ChannelPRO)
    welcome: {
      headerTop: 'Bem-vindo ao',
      headerBottom: 'Instituto de Turismo de Visita à Flórida Central', // Produto específico
    },
    sellingPoints: {
      // Todos os pontos de venda podem ser específicos do produto
      0: 'Aprenda, Promova e Venda em Movimento',
      1: 'Treinamento Multimídia em Dispositivos',
      2: 'Certificado de Conclusão',
      3: 'Apresentações de Vendas Prontas',
      4: 'Materiais Promocionais de Alto Impacto',
      5: 'Dicas e Promoções Exclusivas',
      6: 'Diretório de Produtos em Tempo Real',
      7: 'Notícias e Atualizações Oportunas',
    },
    emailPrompt:
      'Por favor, insira seu endereço de e-mail e senha para confirmar que você é um profissional de viagens.', // Produto específico (texto de TravPRO ou ChannelPRO)
    tAndC: {
      agree: 'Ao continuar, você concorda com nossa ',
      privacyPolicy: 'política de privacidade',
      and: ' e ',
      termsConditions: 'termos e condições',
    },
    fields: {
      what: 'Que tipo de viagens você vende?',
      what1: 'Qual é o tipo de viagem #1 que você vende?',
      what2: 'Qual é o tipo de viagem #2 que você vende?',
      what3: 'Qual é o tipo de viagem #3 que você vende?',
      agency: 'Agência *',
      email: 'E-mail',
      password: 'Senha',
      passwordConfirm: 'Confirme sua senha *',
      firstName: 'Nome *',
      lastName: 'Sobrenome *',
      agencyName: 'Nome da Agência *',
      city: 'Cidade *',
      stateProvince: 'Estado / Província *',
      salutation: 'Saudação *',
      required: 'Obrigatório',
      invalidEmail: 'Endereço de e-mail inválido',
      opt: 'Mantenha-se em contato! Sim, eu gostaria de optar por receber comunicações da Visita à Flórida Central que me manterão informado sobre notícias, eventos, incentivos, FAMs e muito mais!',
      complete: 'Passo 2: Complete seu perfil',
      tell: 'Conte-nos Sobre Você',
      title: 'Título Comercial *',
      host: 'Nome da Agência Anfitriã',
      country: 'País / Região',
      select: 'Por favor, selecione uma opção abaixo',
      header2: 'Quais segmentos você vende principalmente?',
      step2: 'Descreva Seu Negócio',
      leisure: 'Lazer',
      corporate: 'Corporativo',
      group: 'Grupo',
      affiliate: 'Qual é sua Principal Afiliação?',
      forgot:
        'Esqueceu sua senha? Clique no botão abaixo e enviaremos um e-mail para redefinir sua senha.',
    },
    noAgent: {
      noAgentButton: 'Eu não sou um consultor',
      title: 'Obrigado pelo seu interesse na Visita à Flórida Central.', // Produto específico
      messageWeb:
        'O conteúdo deste site é exclusivamente para profissionais de viagens. \n Para saber mais sobre a Visita à Flórida Central, visite: ', // Produto específico
      messageMobile:
        "Parte do conteúdo deste aplicativo é exclusivamente para profissionais de viagens, mas sinta-se à vontade para explorar uma prévia do que este aplicativo tem a oferecer pressionando 'Continuar'.", // Produto específico
      continue: 'Continuar',
      visitWebsite: 'Visitar site',
    },
    newUser: 'Novo Usuário',
    register: 'Registrar',
    registered: 'Este e-mail já está registrado',
    forgot: 'Redefinir Senha',
    header:
      'Por favor, reserve um momento para preencher todas as informações abaixo, pois isso preencherá seu perfil e informações de contato.',
    step1: 'Passo 1: Complete seu endereço de e-mail e escolha uma senha.',
  },
  welcomeScreen: {
    title: 'Bem-vindo ao Instituto de Turismo de Visita à Flórida Central', // Produto específico
    helloUser: 'Olá {{name}}',
    hello: 'Olá,',
    fromAgency: 'da {{agency}}',
    notUser: 'Não é {{name}}?',
    introOnline:
      'Treine imediatamente online ou pré-carregue o conteúdo para que esteja sempre disponível para uso offline!',
    introOffline:
      'Você já tem a versão mais recente pré-carregada. Comece a treinar ou vender a qualquer momento, em qualquer lugar!',
    startTraining: 'Comece a aprender',
    continueTraining: 'Continue aprendendo',
    graduated: 'Parabéns!',
    downloader: {
      preload: 'Pré-carregar',
      stop: 'parar',
      init: 'Inicializando...',
      lastUpdate: 'Última atualização: ',
    },
  },
  trainingScreens: {
    start: 'Começar',
    continue: 'Continuar',
    review: 'Revisar',
    restart: 'Reiniciar',
    durationInMinutes: '{number} minutos',
    percentageComplete: '{number}% Completo',
    unlock:
      'Desbloqueie este capítulo completando o capítulo de treinamento {number}.',
    unlockSubtitle:
      'Desbloqueie mais capítulos completando capítulos de treinamento.',
    allUnlocked: 'Você desbloqueou todos os capítulos!',
    certificate: 'Certificado',
    courseComplete: 'Continuar',
    endReached: 'Você chegou ao fim',
    retainEnd:
      'Use a barra superior para navegar neste capítulo ou pressione o botão voltar para retornar à visão geral.',
    watchListenRead: 'Assista, Ouça e Leia mais',
    trouble:
      'Parece que você está tendo problemas, por favor releia o conteúdo nas páginas anteriores e tente novamente.',
    confirm: 'Confirme sua resposta',
    choose: 'Por favor, escolha uma resposta',
    skip: 'Retornar >',
    viewAllTitle: 'Dica de Treinamento',
    viewAll:
      'Para prosseguir para a próxima página, clique nos ícones para ver o conteúdo suplementar. Vídeos, mapas e outras informações úteis foram fornecidos para melhorar seu treinamento e garantir que você alcance o status de PRO.',
    fillBlanks: 'Preencha o(s) espaço(s) em branco:',
    next: 'Próxima pergunta',
    retry: 'Tente Novamente',
    fastTrackText: {
      success:
        'Parabéns, você passou no curso Fast Track e desbloqueou o restante do treinamento!',
      failed:
        'Infelizmente você não passou no curso Fast Track, você pode retomar seu treinamento para ganhar seu diploma!',
    },
    fastTrack: 'Torne-se uma Superestrela de Viagens na Suíça!',
    fastTrackExplanation:
      'Basta fazer o questionário nas próximas páginas para sua chance de ganhar um FAM para a Suíça!<br><br><span style="font-weight: bold">Você encontrará todas as respostas para as perguntas do questionário das seguintes maneiras:</span><br><br>1.	O conteúdo que você aprendeu nos módulos da Rail Europe e Suíça<br><br>2.	E nos seguintes sites:<br><a href="https://www.myswitzerland.com" target="_blank">www.myswitzerland.com</a><br><a href="https://www.bucherer.com" target="_blank">www.bucherer.com</a><br><a href="https://www.mysts.net" target="_blank">www.mysts.net</a><br><br><span style="font-weight: bold">Certifique-se de revisar esses recursos em detalhes antes de fazer o questionário! Apenas aqueles com as pontuações mais altas terão a chance de ser convidados para o FAM.</span>',
    fastTrackButton:
      'Clique Aqui para Fazer o Questionário de Superestrela Suíça',
    grading: 'Sua nota final é: {grade}%',
  },
  nav: {
    home: 'Início',
    train: 'Treinar',
    learn: 'Aprender',
    retain: 'Reter',
    directory: 'Diretório',
    showRoom: 'Exposições',
    showcases: 'Exposições',
    offers: 'Ofertas',
    promote: 'Promover',
    sell: 'Vender',
    info: 'Informações',
    rewards: 'Recompensas',
    media: 'Mídia',
    favorites: 'Favoritos',
    contact: 'Conheça a Equipe',
    reportCard: 'Ver Diploma',
    accountSettings: 'Configurações da Conta',
    messages: 'Mensagens',
    search: 'Buscar',
  },
  contentHeaders: {
    train: 'Treinar',
    retain: 'Reter',
    subapps:
      'Módulos de Parceiros do Instituto de Turismo de Visita à Flórida Central',
    maintrainings: 'A Base',
    subtrainings: 'A Experiência',
  },
  pageDescriptions: {
    train: 'Eduque, envolva-se e torne-se o especialista.',
    showroom: '',
    retain:
      'Parabéns por completar seu treinamento! Você agora desbloqueou seu recurso para reter seu conhecimento especializado e habilitar seus esforços de vendas. Use esta área para responder a uma pergunta de produto de maneira especializada ou até mesmo como uma apresentação de vendas improvisada — a qualquer momento, em qualquer lugar e em qualquer dispositivo.',
    promote:
      'Compartilhe estes itens para gerar interesse e iniciar uma conversa com clientes e prospectos.',
    sell: 'Responda perguntas dos clientes e feche a venda como um profissional com recursos profundos e suporte de vendas direcionado.',
    favorites: 'Confira seu conteúdo favorito pessoal',
    search: 'Procure por todo o conteúdo',
    subapps: '',
    maintrainings:
      'Complete estes módulos essenciais para ganhar seu certificado.',
    subtrainings:
      'Complete estes módulos sobre todas as coisas incríveis que os clientes podem fazer e ver com a Visita à Flórida Central e receba seu certificado como Especialista do Instituto de Turismo de Visita à Flórida Central.',
  },
  general: {
    next: 'Próximo',
    yes: 'Sim',
    no: 'Não',
    previous: 'Anterior',
    submit: 'Enviar',
    back: 'Voltar',
    close: 'Fechar',
    page: 'Página',
    search: 'Buscar',
    logIn: 'Entrar',
    logOut: 'Sair',
    viewItem: 'Ver {type}',
    imageNotFound: 'Imagem não encontrada',
    noResultsFor: 'Nenhum resultado encontrado para: {{query}}',
    noFavorites: 'Você ainda não tem favoritos.',
    noMessages: 'Você ainda não recebeu mensagens!',
    resultsFor: 'Resultados para: {{query}}',
    showAll: 'Mostrar tudo',
    connectionError: 'Erro de conexão',
    alreadyExists: 'Já existe',
    pageNotFound: 'Página 404 Não Encontrada!',
    oops: 'Uh oh...',
    overview: 'Voltar à visão geral',
    complete: 'Continuar',
    courseComplete: 'Capítulo Completo!',
    chapterComplete: 'Capítulo Concluído!',
    message: '{count} Mensagem',
    messagePlural: '{count} Mensagens',
  },
  itemTypes: {
    image: 'Imagem',
    brochure: 'Coleção',
    layout: 'Layout',
    web: 'Website',
    pdf: 'PDF',
    carousel: 'Coleção',
  },
  questions: {
    dials: 'Gire os mostradores para coincidir com a resposta',
    fitb: 'Preencha o(s) espaço(s) em branco',
    flip: 'Mude o número para coincidir com a resposta',
    multipleChoice: 'Escolha a(s) resposta(s) correta(s)',
    slider: 'Escolha a resposta correta usando o controle deslizante',
    map: 'Responda à pergunta tocando no local correto no mapa',
    dropdown: 'Escolha...',
    true: 'Verdadeiro',
    false: 'Falso',
  },
  reportCard: {
    download: 'Baixar',
    email: 'E-mail',
    print: 'Imprimir',
  },
  cookies: {
    consent: 'ACEITAR',
    optout: 'Optar por não',
    settings: 'Configurações de Privacidade',
    message:
      'Você não nos disse nada sobre suas preferências de privacidade de dados! Tudo bem, mas gostaríamos de oferecer a melhor experiência usando o Sales Companion.',
    disabled: 'Parece que você desativou o uso de cookies.',
    use: 'O {appName} requer o uso de cookies para oferecer a melhor experiência.',
    details: 'Para que são usados os cookies?',
    enable: 'Veja como habilitar seus cookies {here}.',
    here: 'aqui',
  },
  notLoggedIn: {
    super: 'Você não está logado',
    title: 'Você precisa estar logado para visualizar este conteúdo',
    guest: 'Convidado',
  },
  demo: {
    message:
      'Este site é uma demonstração do produto final. Está atualmente em desenvolvimento e não é um produto completo.',
    consent: 'Entendi!',
  },
  share: {
    header: 'Compartilhe este recurso na sua rede social favorita!',
    download: 'Baixar',
  },
  sharing: {
    copyURL: 'Copiar Link',
    copied: 'Copiado',
  },
  breadCrumbs: {
    page: 'Página',
  },
  onMobile: {
    header:
      'Parece que você está tentando acessar o aplicativo {appName} de um dispositivo móvel',
    body: 'Para baixar este programa, visite sua loja de aplicativos e procure por {appName} ou clique em um dos botões abaixo',
    benefits: {
      header: 'Isso lhe proporcionará:',
      1: 'Aprenda, Promova e Venda em Movimento',
      2: 'Treinamento Multimídia em Dispositivos',
      3: 'Certificado de Conclusão',
      4: 'Apresentações de Vendas Prontas',
      5: 'Materiais Promocionais de Alto Impacto',
      6: 'Diretório de Produtos em Tempo Real',
      7: 'Notícias e Atualizações Oportunas',
    },
  },
  directoryView: {
    search: 'Buscar...',
    amountOfResults: 'Quantidade de resultados:',
    filter: 'Filtrar',
    filters: 'Filtros:',
    resetFilters: 'Redefinir Filtros',
    showResults: 'Mostrar Resultados',
    noResults:
      'Nenhum resultado encontrado. Por favor, tente com uma busca diferente.',
    resetMap: 'Redefinir Mapa para Início >',
    viewNow: 'Ver Agora >',
  },
  directory: {
    artsentertainment: 'Artes e Entretenimento',
    conventionservices: 'Serviços para Convenções',
    divingsnorkeling: 'Mergulho e Snorkel',
    film: 'Filme',
    hotels: 'Hotéis',
    lgbtgymsandspas: 'LGBT+: Academias e Spas',
    lgbtshopping: 'LGBT+: Compras',
    lgbtwheretostay: 'LGBT+: Onde Ficar',
    multiculturaldining: 'Multicultural: Refeições',
    multiculturalnightlife: 'Multicultural: Vida Noturna',
    nightlife: 'Vida Noturna',
    petfriendly: 'Amigável com Animais de Estimação',
    restaurants: 'Restaurantes',
    shopping: 'Compras',
    spas: 'Spas',
    sports: 'Esportes',
    transportation: 'Transporte',
    venues: 'Locais',
    waterways: 'Vias Navegáveis',
    waystoplay: 'Formas de Brincar',
    weddinglocations: 'Locais para Casamentos',
    weddingvendors: 'Fornecedores de Casamentos',
  },
  preregisterview: {},
  rewards: {
    rewards: 'Recompensas',
    title: 'RECOMPENSAS da Visita à Flórida Central',
    subTitle:
      'Estamos dando a você a chance de ganhar recompensas por se tornar um especialista com nosso programa e reservar viagens com a Visita à Flórida Central!',
    body: 'Reserve viagens com a Visita à Flórida Central para ter a chance de ganhar! Insira suas reservas para ser elegível para ganhar uma Recompensa de Incentivo de Introdução de $5 US/CAN em Cartão de Presente Eletrônico.',
    item1:
      'Após sua primeira reserva confirmada de 4 noites ou mais, (para uma reserva individual), para um mínimo de dois (2) passageiros, em um hotel/resort qualificado. (Cruzeiros não qualificam.)',
    item2:
      'A oferta é válida após a conclusão dos Módulos Essenciais do Programa de Instituto de Turismo da Visita à Flórida Central.',
    link1: 'Você reservou com a Visita à Flórida Central? ',
    link2: 'Se sim, envie sua reserva aqui.',
    button: 'Enviar sua reserva',
    bookingForm: {
      title: 'RECOMPENSAS da Visita à Flórida Central',
      subTitle: 'Insira sua reserva:',
      required: '* Indica um campo obrigatório',
      email: 'E-mail do Agente',
      agentFirstName: 'Nome do Agente',
      agentLastName: 'Sobrenome do Agente',
      company: 'Nome da Empresa',
      iata: 'IATA/CLIA #',
      stateProvince: 'Estado / Província',
      postalCode: 'CEP',
      country: 'País',
      bookingNumber: 'Número da Reserva',
      numberOfGuests: 'Número de Hóspedes Adultos',
      bookingDate: 'Data da Reserva',
      tourOperator: 'Operador de Turismo',
      firstName: 'Nome',
      lastName: 'Sobrenome',
      accommodation: 'Nome da Acomodação',
      wholesaler:
        'Nome do Atacadista (se aplicável): se for uma reserva direta, insira NENHUM',
      arrivalDate: 'Data de Chegada',
      departureDate: 'Data de Saída',
      reservationNumber: 'Número da Reserva',
      rooms: 'Número de Quartos',
      stay: 'Duração da Estadia (em Noites)',
      airline: 'Companhia Aérea / Transportadora (código de 2 dígitos)',
      gateway: 'Porta de Origem (código de 3 letras do aeroporto)',
      destination: 'Destino / ilha (código de 3 letras do aeroporto)',
      cost: 'Custo (usar apenas decimais)',
      disclaimer: '* Campos obrigatórios',
      button: 'Enviar sua reserva',
      sub: 'Suas informações',
      sub2: 'Informações da reserva',
    },
    TermsAndConditions: {
      title: 'Termos e Condições',
      subTitle: 'Recompensas Trimestrais para Especialistas em Bahamas',
      body1:
        'Todas as postagens devem ser acompanhadas por um documento de prova de venda com saldo zero que corresponda a cada reserva individual que você postou. Os ganhadores serão selecionados com base na totalidade de documentos de prova de venda verificados que correspondam a cada reserva listada. As postagens devem seguir todas as regras de elegibilidade das Recompensas para Especialistas em Bahamas. As recompensas não são transferíveis e devem ser resgatadas dentro de três (3) meses após a notificação da recompensa. Quaisquer recompensas não utilizadas, não reclamadas ou recusadas serão anuladas. As recompensas serão emitidas trimestralmente e a elegibilidade será verificada com base nas viagens concluídas.',
      body2:
        'Para ser elegível, você deve residir nos EUA ou Canadá e ser maior de idade no estado, província ou território de residência. Funcionários de Operadores de Turismo NÃO são elegíveis para sorteios e NÃO serão considerados para prêmios adicionais. Os residentes da província de Quebec NÃO são elegíveis para sorteios e NÃO serão considerados para prêmios adicionais.',
      body3:
        'A emissão de recompensas pode exigir prova de credenciamento como consultor de viagens de varejo / baseado em casa. As recompensas disponíveis estão sujeitas a alterações durante o curso do programa.',
      body4: 'Privacidade e Uso de Informações Pessoais',
      body5:
        'Os agentes participantes (i) concedem ao Recompensador o direito de usar seu nome, cidade, estado, província, código postal, confirmação de maioridade, número de telefone e endereço de e-mail para, entre outros, entrar em contato e anunciar os vencedores e a provisão de recompensas; (ii) concedem ao Recompensador o direito de usar suas informações pessoais para fins publicitários e promocionais relacionados às recompensas, em qualquer e todos os meios agora conhecidos ou que venham a ser inventados no futuro, sem compensação adicional, a menos que proibido por lei; e (iii) reconhecem que o Recompensador pode divulgar suas informações pessoais a agentes de terceiros e prestadores de serviços em conexão com quaisquer das atividades listadas em (i) e (ii) acima.',
      button: 'Voltar para a página inicial',
    },
    thankYouPage: {
      thanks: 'Obrigado',
      congrats: 'Parabéns, ',
      body: 'sua reserva foi recebida e enviada ao supervisor da campanha para verificação.',

      link: 'Por favor, note que para ser um vencedor, você deve ter concluído os Módulos Essenciais do Programa de Especialistas em Bahamas',
    },
  },
  custom: {
    splitUsers: 'Eu sou um ...',
    brandAmbassador: 'Embaixador da Marca',
    travelPro: 'Profissional de Viagens',
  },
  search: {
    pages: 'Páginas',
    resources: 'Recursos',
  },
};
